import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import { EmptyState } from '@/components'
import { getSafeErrorMessage } from '@/utils/errors'

export function RouteErrorPage() {
  const error = useRouteError()
  const message = isRouteErrorResponse(error)
    ? `A rota respondeu com o código ${error.status}.`
    : getSafeErrorMessage(error)

  return (
    <main className="fatal-error" role="alert">
      <EmptyState title="Não foi possível abrir esta página" description={message} />
    </main>
  )
}
